import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=674918d2&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage, CHeading: require('@chakra-ui/vue').CHeading, CText: require('@chakra-ui/vue').CText, CBox: require('@chakra-ui/vue').CBox, CButton: require('@chakra-ui/vue').CButton, CListItem: require('@chakra-ui/vue').CListItem, CList: require('@chakra-ui/vue').CList, CFlex: require('@chakra-ui/vue').CFlex})
